const fontFamily = "'Nunito Sans', sans-serif";

const setStyles = {
  maxWidth: "960px",
  setFlexRow: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  containerRow: {
    maxWidth: "960px",
    margin: "auto auto 50px",
  },
  setSecondaryHeading: {
    marginTop: "0px",
    paddingTop: "25px",
  },
  setCardsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexFirection: "row",
  },
  nunitoSansBlack: {
    fontFamily: fontFamily,
    fontWeight: 900,
    fontStyle: "normal",
  },
  nunitoSansBold: {
    fontFamily: fontFamily,
    fontWeight: 700,
    fontStyle: "normal",
  },
  nunitoSansRegular: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
  },
  nunitoSansRegularItalic: {
    fontFamily: fontFamily,
    fontWeight: 400,
    fontStyle: "italic",
  },
  nunitoSansSemiBold: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontStyle: "normal",
  },
  nunitoSansSemiBoldItalic: {
    fontFamily: fontFamily,
    fontWeight: 600,
    fontStyle: "italic",
  },
  nunitoSansLight: {
    fontFamily: fontFamily,
    fontWeight: 200,
    fontStyle: "normal",
  },
};

export default setStyles;
